import React from 'react'
import {ISectionList, ISectionProps} from '../../../../interfaces/pages/portfolio/ISection'
import {ILang} from "../../../../interfaces/IGeneral";

const List = (props: ISectionProps) => {
    const section = props.section as ISectionList
    return (
        <ul>
            {
                section.items.map((item: ILang) =>
                    <li>{item[props.lang]}</li>
                )
            }
        </ul>
    )
}

export default List